import { Link } from "react-router-dom";

const newsTitle = "Want Us To Email You About Special Offers And Updates?";
const coursesTitle = "Our Courses";
const connectTitle = "Connect With Us";
const aboutTitle = "About Us";

const coursesList = [
    {
        text: 'Arduino',
        link: '#',
    },
    {
        text: 'Block Programming',
        link: '#',
    },
    {
        text: 'Engineering',
        link: '#',
    },
    {
        text: 'LEGO Activity',
        link: '#',
    },
    {
        text: 'Coding',
        link: '#',
    },
]

const connectList = [
    {
        text: 'Instagram',
        link: '#',
    },
    {
        text: 'Facebook',
        link: '#',
    },
    {
        text: 'Tiktok',
        link: '#',
    },
    {
        text: 'Phone',
        link: '#',
    },
    {
        text: 'Email',
        link: '#',
    },
]

const aboutList = [
    {
        text: 'About Us',
        link: '#',
    },
    {
        text: 'What We Offer',
        link: '#',  
    },
    {
        text: 'Privacy Policy',
        link: '#',
    },
    {
        text: 'Careers',
        link: '#',
    },
    {
        text: 'Projects',
        link: '#',
    },
]

const Footer = () => {
    return (
        <div className="news-footer-wrap" style={{ backgroundColor: 'var(--theme-tertiary-color)' }}>
            <div className="fs-shape">
                <img src="assets/images/shape-img/2_triangles.png" alt="fst" className="fst-1" style={{width: '15%', height: 'auto'}} />
                <img src="assets/images/shape-img/2_triangles.png" alt="fst" className="fst-2" style={{width: '15%', height: 'auto', transform: 'scaleY(-1)'}} />
            </div>
            
            <div className="news-letter">
                <div className="container">
                    <div className="section-wrapper">
                        <div className="news-title">
                            <h3>{newsTitle}</h3>
                        </div>
                        <div className="news-form">
                            <form action="/">
                                <div className="nf-list primary-airplane">
                                    <input type="email" name="email" placeholder="Enter Your Email" />
                                    <input type="submit" name="submit" value="Subscribe Now" style={{ backgroundColor: 'var(--theme-primary-color)' }} />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            
            <footer>
                <div className="footer-top padding-tb pt-0">
                    <div className="container">
                        <div className="row g-4 row-cols-xl-4 row-cols-md-2 row-cols-1 justify-content-center">
                            <div className="col">
                                <div className="footer-item">
                                    <div className="footer-inner">
                                        <div className="footer-content">
                                            <div className="title">
                                                <h4>{coursesTitle}</h4>
                                            </div>
                                            <div className="content">
                                                <ul className="lab-ul">
                                                    {coursesList.map((val, i) => (
                                                        <li key={i}><a href={val.link}>{val.text}</a></li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="footer-item">
                                    <div className="footer-inner">
                                        <div className="footer-content">
                                            <div className="title">
                                                <h4>{connectTitle}</h4>
                                            </div>
                                            <div className="content">
                                                <ul className="lab-ul">
                                                    {connectList.map((val, i) => (
                                                        <li key={i}><a href={val.link}>{val.text}</a></li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="footer-item">
                                    <div className="footer-inner">
                                        <div className="footer-content">
                                            <div className="title">
                                                <h4>{aboutTitle}</h4>
                                            </div>
                                            <div className="content">
                                                <ul className="lab-ul">
                                                    {aboutList.map((val, i) => (
                                                        <li key={i}><a href={val.link}>{val.text}</a></li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom style-2">
                    <div className="container">
                        <div className="section-wrapper">
                            <p>&copy; Copyright {new Date().getFullYear()}, All Rights Reserved by <Link to="/">Mindcraft LB</Link></p>
                        </div>
                    </div>
                </div>
            </footer>
            
            <style>
            {`
                .primary-airplane::after {
                    color: var(--theme-primary-color) !important;
                }
                
                .fst-1 {
                    width: 70%;
                    height: auto;
                }
            `}
            </style>
        </div>
    );
}
 
export default Footer;